"use client";

const quickLinks = ["Home", "About", "Services", "Contact"];
const serviceLinks = [
  "Herbal Therapy",
  "Panchakarma",
  "Yoga & Meditation",
  "Shirodhara",
];

export default function Footer() {
  return (
    <footer className="bg-leaf-900 text-sand-100">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <a href="#home" className="font-display text-2xl font-bold text-white">
            <span className="mr-1">🌿</span>Ayur
            <span className="text-sand-300">Veda</span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-sand-100/70">
            Natural healing, holistic wellness and authentic Ayurvedic care for
            a balanced life.
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-white">Quick Links</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {quickLinks.map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase()}`}
                  className="text-sand-100/70 transition-colors hover:text-sand-300"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white">Services</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {serviceLinks.map((l) => (
              <li key={l}>
                <a
                  href="#services"
                  className="text-sand-100/70 transition-colors hover:text-sand-300"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white">Newsletter</h4>
          <p className="mt-4 text-sm text-sand-100/70">
            Subscribe for wellness tips &amp; offers.
          </p>
          <form
            onSubmit={(e) => e.preventDefault()}
            className="mt-4 flex overflow-hidden rounded-full bg-white/10 p-1"
          >
            <input
              type="email"
              placeholder="Your email"
              className="w-full bg-transparent px-4 py-2 text-sm text-white outline-none placeholder:text-sand-100/40"
            />
            <button className="shrink-0 rounded-full bg-leaf-500 px-4 py-2 font-semibold text-white transition-colors hover:bg-leaf-400">
              →
            </button>
          </form>
        </div>
      </div>

      <div className="flex flex-col items-center gap-2 border-t border-white/10 py-6 text-center text-sm text-sand-100/60 sm:flex-row sm:justify-center sm:gap-4">
        <span>
          © 2026 AyurVeda. All rights reserved. Made with 🌱 for natural
          wellness.
        </span>
        <a
          href="/admin/login"
          className="text-sand-300 transition-colors hover:text-white"
        >
          Admin Login
        </a>
      </div>
    </footer>
  );
}
